
export const calculateGrossTotal = (items) => {
    return items.reduce((total, item) => {
        return total + (parseFloat(item.line_amount) || 0);
    }, 0);
};

export const calculateOverallDiscount = (grossTotal, discountPercent, discountAmount) => {
    if (discountPercent > 0) {
        return (grossTotal * discountPercent) / 100;
    }
    return parseFloat(discountAmount) || 0;
};

export const distributeHeaderDiscount = (items, overallDiscountAmount) => {
    const grossTotal = calculateGrossTotal(items);
    // if (grossTotal <= 0) return items;

    return items.map(item => {
        const lineAmount = parseFloat(item.line_amount) || 0;
        // const weight = lineAmount / grossTotal;
        const weight = (lineAmount <= 0) ? 0 : lineAmount / grossTotal;
        
        const headerDiscount = (overallDiscountAmount * weight).toFixed(3);
        
        // Calculate amount excluding VAT
        const amountExclVat = lineAmount - parseFloat(headerDiscount);
        
        // Calculate VAT
        const vatPercent = parseFloat(item.vat_percentage) || 0;
        const vatAmount = (amountExclVat * vatPercent) / 100;
        
        // Calculate amount including VAT
        const amountInclVat = amountExclVat + vatAmount;
        
        return {
            ...item,
            header_discount: headerDiscount,
            amount_excl_vat: amountExclVat.toFixed(3),
            vat_amount: vatAmount.toFixed(3),
            amount_incl_vat: amountInclVat.toFixed(3)
        };
    });
};

export const calculateTotals = (items) => {
    return items.reduce((acc, item) => {
        acc.grossTotal += parseFloat(item.line_amount) || 0;
        acc.vatAmount += parseFloat(item.vat_amount) || 0;
        acc.netTotal += parseFloat(item.amount_incl_vat) || 0;
        return acc;
    }, {
        grossTotal: 0,
        vatAmount: 0,
        netTotal: 0
    });
};